export default __webpack_public_path__ + "static/media/ic-active-tech.40440e59.svg";